// 系统中用到的链接

const env = process.env.NODE_ENV;
const REACT_APP_OLDER_SITE_DOMAIN = process.env.REACT_APP_OLDER_SITE_DOMAIN
const REACT_APP_OA_DOMAIN = process.env.REACT_APP_OA_DOMAIN
const REACT_APP_OLD_OP_SITE_DOMAIN = process.env.REACT_APP_OLD_OP_SITE_DOMAIN
const REACT_APP_OP_SITE_DOMAIN = process.env.REACT_APP_OP_SITE_DOMAIN
const REACT_APP_ORDER_DETAIL_URL = process.env.REACT_APP_ORDER_DETAIL_URL

// 获取前缀  args:0 表示测试环境或预上线环境
// const getPrefix = args => {
//   env === "development" ? args[0] : args[1]
// };

// google地图地址
export const getGoogleMapAddr = `${REACT_APP_OA_DOMAIN}/Map/index`;
// 满位通知
export const getMWAddr = `${REACT_APP_OA_DOMAIN}/Admin/Knowledge/read/id/58/acc/fromWork/key/VYVXnUlk72wb9MzUmRZLPEqjYujAqy`;
// 仙本那房态查询
export const getXBNAddr = `${REACT_APP_OA_DOMAIN}/Admin/Knowledge/read/id/67.html`;
// 库存查位
export const getKCAddr = `${REACT_APP_OA_DOMAIN}/Admin/Sale_stock/index/acc/fromWork/key/VYVXnUlk72wb9MzUmRZLPEqjYujAqy`;
export const getKCAddrNew = `${REACT_APP_OA_DOMAIN}/redirect.php?param=oa_stock_list`;
// 酒店接送和区域查询
export const getHotelSearchAddr = `${REACT_APP_OLDER_SITE_DOMAIN}/order/jumpUrlWithToken?url=http://www.transferasia.com/Data/index/key/`;
// 运营后台
export const getYYAddr = `${REACT_APP_OLD_OP_SITE_DOMAIN}`

export const getYYAddrNew = `${REACT_APP_OP_SITE_DOMAIN}`

// @var@ 用于占位的变量
export enum EUrl {
  // 旺旺地址
  wangwang = "https://amos.alicdn.com/getcid.aw?spm=2013.1.0.0.639ea0fdpRotk0&v=3&groupid=0&s=1&charset=utf-8&uid=@var@&site=cntaobao&fromid=cntaobao",
  // 新增订单
  addOrder = "@host@/admin.php/order/neworder",
  // 批量导入订单  (马蜂窝)
  importOrderMFW = "@host@/admin.php/order/importorder",
  // 批量导入订单（携程）
  importOrderXC = "@host@/admin.php/order/importorder/xie",
  // 批量导入订单（去哪儿）
  importOrderQNR = "@host@/admin.php/order/importorder/qu",
  // 订单详情(订单id)
  orderDetail = "@host@/admin.php/order/itemdetails/id/@var@",
  // 商城订单-查看未付款订单
  noPay = "@host@/admin.php/order/itemlist/item/4",
  // 用户功能相关-修改密码
  updPwd = "@host@/user_manage/editUserPwdSelf",
  // 新增定制单
  addCustomOrder = "/app/customOrderList",
}

const getAPIHost = () => {
  if (env === "development") {
    return "http://admin.cattrip.net";
  } else {
    // 正式环境
    return process.env.REACT_APP_OLDER_SITE_DOMAIN;
  }
};

// 获取websocket地址
export const getWebSocketAddr = () => {
  if (env === "development") {
    // 本机测试地址
    // return "ws://192.168.100.124:8083";
    //  预上线地址
    return "ws://erpapi.cattrip.net:8032";
  } else {
    // 正式环境
    return "ws://erpapi.cattour.cn:8032";
  }
};

// 获取地址头
export const getUrlHead = () => {
  if (env === "development") {
    return "http://";
  } else {
    // 正式环境
    return "https://";
  }
};

const hostUrl = getAPIHost();
// 转换接口地址
export const transformUrl = (url: EUrl, host = hostUrl, variable = null) => {
  let newUrl: any = url;
  if (newUrl) {
    newUrl = newUrl.replace("@host@", host);
    newUrl = newUrl.replace("@var@", variable);
  }
  return newUrl;
};

export const orderDetailUrl = (url: EUrl, variable = null) => {
  // let newUrl: any;
  // if (env === "development" || env === "test") {
  //   newUrl = "http://localhost:3000/app/orderDetails/" + variable;
  // } else if (env === "beta" || env === "beta_hash") {
  //   newUrl = "https://front.cattrip.net/app/orderDetails/" + variable;
  //   // newUrl = "https://admin.cattrip.net/order/itemdetails/id/"+variable;
  // } else {
  //   //newUrl = "https://front.cattour.cn/app/orderDetails/"+variable;
  //   newUrl = "https://admin.cattour.cn/order/itemdetails/id/" + variable;
  // }
  // return newUrl;
  return env === "development" ? `https://admin.cattrip.net/admin.php/order/itemdetails/id/${variable}` : `${REACT_APP_ORDER_DETAIL_URL}${variable}`
};
